import TrendEmpty from './TrendEmpty';

export default TrendEmpty;
